"use strict";

import Vue from "vue";
import axios from "axios";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import Vuex from "vuex";
import { sync } from "vuex-router-sync";
import marked from "marked";
import VueSimpleSVG from "vue-simple-svg";
import VModal from "vue-js-modal";
import VueYouTubeEmbed from "vue-youtube-embed";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueAnnouncer from "vue-announcer";
import VueLazyload from "vue-lazyload";
import moment from "moment";
import VueCookies from "vue-cookies";
import ScrollAnimation from "../../../src/directives/scrollanimation";

Vue.directive("scrollanimation", ScrollAnimation);
/**
 * Disable Vue dev tools when compiling to production
 */
if (process.env.NODE_ENV == "production") {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
  Vue.config.productionTip = false;
}

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "metaInfo", // the component option name that vue-meta looks for meta info on.
  attribute: "data-vue-meta", // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: "data-vue-meta-server-rendered", // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: "vmid" // the property name that vue-meta uses to determine whether to overwrite or append a
});
Vue.use(Vuex);
Vue.use(VModal, { dynamic: true });
Vue.use(VueSimpleSVG);
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" });
Vue.use(VueAwesomeSwiper);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  observer: true,
  attempt: 1,
  error: "/assets/images/error.png"
  //loading: '/assets/images/svg-icons/loading-svg.svg'
});
Vue.use(VueCookies);
Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  }
});

/** Format Date with moment */
Vue.filter("formatDate", function(value) {
  if (value) {
    //console.log('1- value: ', value);
    var dateString = String(value);
    //updates to moment to work in safari
    //return moment(String(value)).format('MMMM Do YYYY');
    //return moment(date).format('MMMM dd, yyyy');
    //console.log(moment(date, "YYYY-MM-DD HH:mm:ss A").format('MMMM Do, YYYY'));
    return moment(dateString, "YYYY-MM-DD HH:mm:ss A").format("MMMM Do YYYY");
  }
});

/** REMOVED - moment updated - Format Date with moment */
/*
var formatDateFilter = function(value) {
  if (value) {
    let value = moment(value).toISOString(); // or format() - see below
    return moment(value).format('MMMM Do YYYsY');
  }
};
*/
/** Format Date filter */
//Vue.filter('formatDate', formatDateFilter);

/*
 * content truncate filter
 */

var truncateFilter = function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", truncateFilter);

var markedFilter = function(input) {
  return marked(input);
};

Vue.filter("markdownify", markedFilter);

Vue.filter("striphtml", function(value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});

Vue.mixin({
  methods: {
    marked: function(input) {
      return marked(input);
    }
  },
  mounted() {
    this.$nextTick(() => {});
  },
  beforeDestroy() {}
});

import App from "../../../src/components/app.vue";
import Home from "../../../src/components/home.vue";
import Tickets from "../../../src/components/tickets.vue";
import PremiumExperiences from "../../../src/components/premium-experiences.vue";
import Cabanas from "../../../src/components/cabanas.vue";
import Info from "../../../src/components/info.vue";
import Lineup from "../../../src/components/lineup.vue";
import Experience from "../../../src/components/experience.vue";
import News from "../../../src/components/news.vue";
import NewsDetail from "../../../src/components/news-detail.vue";
import Press from "../../../src/components/press.vue";
import NeighborhoodDetail from "../../../src/components/neighborhood-detail.vue";
import GenericPage from "../../../src/components/generic-page.vue";
import GenericPageNoVid from "../../../src/components/generic-page-no-vid.vue";
import OLWorks from "../../../src/components/olworks.vue";
import Search from "../../../src/components/search.vue";
import WasteDiversion from "../../../src/components/waste-diversion.vue";
import NonProfitPartners from "../../../src/components/nonprofit-partners.vue";
import PastLineups from "../../../src/components/past-lineups.vue";
import GrassLandsPartners from "../../../src/components/grass-lands-partners.vue";
import RestaurantPartners from "../../../src/components/restaurant-partners.vue";
import SomaTent from "../../../src/components/soma-tent.vue";
import NightShows from "../../../src/components/night-shows-old.vue";
import BeerLands from "../../../src/components/beer-lands.vue";
import CocktailMagic from "../../../src/components/cocktail-magic.vue";
import WineLands from "../../../src/components/wine-lands.vue";
import Wristbands from "../../../src/components/wristbands.vue";
import InsideLands from "../../../src/components/insidelands.vue";
import TakeAction from "../../../src/components/take-action.vue";
import Signup from "../../../src/components/signup.vue";
import ThreeOneOneEnglish from "../../../src/components/311-english.vue";
import OutsiderArt from "../../../src/components/outsider-art.vue";
import GastroMagic from "../../../src/components/gastro-magic.vue";
import WestCoast from "../../../src/components/west-coast-craft-v2.vue";
import HealthAndSafety from "../../../src/components/health-and-safety.vue";
import Schedule from "../../../src/components/schedule.vue";

// import ScrollAnimation from "../../../src/directives/scrollanimation.js";

// Vue.directive("scrollanimation", ScrollAnimation);
/*
 * Lazy Loading Async Components
 */
//const Home = () => import("../../../src/components/home-rev-slideshow.vue");

const routes = [
  {
    path: "/",
    component: Home,
    props: { pageMarkdownFileName: "index.markdown" },
    name: "home"
  },
  {
    path: "/tickets/",
    component: Tickets,
    props: { pageMarkdownFileName: "tickets.markdown" },
    name: "tickets"
  },
  {
    path: "/premium-experiences/",
    component: PremiumExperiences,
    props: { pageMarkdownFileName: "premium-experiences.markdown" },
    name: "premium-experiences"
  },
  {
    path: "/lineup/",
    component: Lineup,
    props: { pageMarkdownFileName: "lineup.markdown" },
    name: "lineup"
  },
  {
    path: "/insidelands/",
    component: InsideLands,
    props: { pageMarkdownFileName: "inside-lands.markdown" },
    name: "inside-lands"
  },
  {
    path: "/take-action/",
    component: TakeAction,
    props: { pageMarkdownFileName: "take-action.markdown" },
    name: "take-action"
  },
  {
    path: "/experience/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "experience"
  },
  {
    path: "/experience/house-by-heineken/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "house-by-heineken"
  },
  {
    path: "/experience/food-and-drink/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "food-and-drink"
  },
  {
    path: "/experience/comedy-and-talks/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "comedy-and-talks"
  },
  {
    path: "/experience/gastromagic/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "gastromagic"
  },
  {
    path: "/experience/grass-lands/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "grass-lands"
  },
  {
    path: "/outsider-art/art/",
    component: OutsiderArt,
    props: { pageMarkdownFileName: "outsider-art.markdown" },
    name: "art"
  },
  {
    path: "/outsider-art/food-and-drink/",
    component: OutsiderArt,
    props: { pageMarkdownFileName: "outsider-art.markdown" },
    name: "food-and-drink"
  },
  {
    path: "/experience/art/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "art"
  },
  {
    path: "/experience/sustainability/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "sustainability"
  },
  {
    path: "/experience/more-activities/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "more-activities"
  },
  {
    path: "/experience/shopping/",
    component: Experience,
    props: { pageMarkdownFileName: "experience.markdown" },
    name: "shopping"
  },
  {
    path: "/info/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info"
  },
  {
    path: "/info/tickets-and-wristbands/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info-tickets-and-wristbands"
  },
  {
    path: "/info/venue/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info-venue"
  },
  {
    path: "/info/travel-and-transportation/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info-travel-and-transportation"
  },
  {
    path: "/info/cannabis/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info-cannabis"
  },
  {
    path: "/info/get-involved/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info-get-involved"
  },
  {
    path: "/info/safety/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info-safety"
  },
  {
    path: "/news/",
    component: News,
    props: { pageMarkdownFileName: "news.markdown" },
    name: "news"
  },
  {
    path: "/news/:id/",
    component: NewsDetail,
    //props: { pageMarkdownFileName: 'news.markdown' },
    name: "news-detail"
  },
  /*
  { 
    path: '/taste/', 
    component: Taste,
    props: { pageMarkdownFileName: 'taste.markdown' },
    name: 'taste'
  },
  */
  {
    path: "/neighborhood-richmond/",
    component: NeighborhoodDetail,
    props: { pageMarkdownFileName: "neighborhood-richmond.markdown" },
    name: "/neighborhood-richmond/ "
  },
  {
    path: "/neighborhood-sunset/",
    component: NeighborhoodDetail,
    props: { pageMarkdownFileName: "neighborhood-sunset.markdown" },
    name: "/neighborhood-sunset/ "
  },
  {
    path: "/311/",
    component: ThreeOneOneEnglish,
    props: { pageMarkdownFileName: "311.markdown" },
    name: "/311/ "
  },
  {
    path: "/accessibility/",
    component: GenericPage,
    props: { pageMarkdownFileName: "accessibility.markdown" },
    name: "accessibility"
  },
  {
    path: "/transport/",
    component: GenericPageNoVid,
    props: { pageMarkdownFileName: "transport.markdown" },
    name: "travel-and-transportation"
  },
  {
    path: "/privacy-policy/",
    component: GenericPageNoVid,
    props: { pageMarkdownFileName: "privacy-policy.markdown" },
    name: "privacy-policy"
  },
  {
    path: "/terms-and-conditions/",
    component: GenericPageNoVid,
    props: { pageMarkdownFileName: "terms-and-conditions.markdown" },
    name: "terms-and-conditions"
  },
  {
    path: "/contact/",
    component: GenericPage,
    props: { pageMarkdownFileName: "contact.markdown" },
    name: "contact"
  },
  {
    path: "/press/",
    component: Press,
    props: { pageMarkdownFileName: "press.markdown" },
    name: "press"
  },
  {
    path: "/outside-lands-works/",
    component: OLWorks,
    props: { pageMarkdownFileName: "outside-lands-works.markdown" },
    name: "olworks"
  },
  {
    path: "/cabanas/",
    component: Cabanas,
    props: { pageMarkdownFileName: "cabanas.markdown" },
    name: "cabanas"
  },
  {
    path: "/wine-lands/",
    component: WineLands,
    props: { pageMarkdownFileName: "wine-lands.markdown" },
    name: "wine-lands"
  },
  {
    path: "/beer-lands/",
    component: BeerLands,
    props: { pageMarkdownFileName: "beer-lands.markdown" },
    name: "beer-lands"
  },
  {
    path: "/west-coast/",
    component: WestCoast,
    props: { pageMarkdownFileName: "west-coast.markdown" },
    name: "west-coast"
  },
  {
    path: "/wristbands",
    component: Wristbands,
    beforeEnter(to, from, next) {
      window.location.href =
        "https://activation.frontgatetickets.com/#/2021outsidelands";
    }
  },
  {
    path: "/cocktail-magic/",
    component: CocktailMagic,
    props: { pageMarkdownFileName: "cocktail-magic.markdown" },
    name: "cocktail-magic"
  },
  {
    path: "/search/",
    component: Search,
    props: route => ({
      query: "",
      pageMarkdownFileName: "search.markdown"
    }),
    name: "search"
  },
  {
    path: "/signup/",
    component: Signup,
    props: { pageMarkdownFileName: "signup.markdown" },
    name: "signup"
  },
  {
    path: "/wait-list/",
    component: GenericPageNoVid,
    props: { pageMarkdownFileName: "wait-list.markdown" },
    name: "wait-list"
  },
  {
    path: "/waste-diversion/",
    component: WasteDiversion,
    props: { pageMarkdownFileName: "waste-diversion.markdown" },
    name: "waste-diversion"
  },
  {
    path: "/wristbands",
    component: Wristbands,
    beforeEnter(to, from, next) {
      window.location.href =
        "https://activation.frontgatetickets.com/#/2021outsidelands";
    }
  },
  {
    path: "/non-profit-partners/",
    component: NonProfitPartners,
    props: { pageMarkdownFileName: "non-profit-partners.markdown" },
    name: "non-profit-partners"
  },
  {
    path: "/page-not-found/",
    component: GenericPageNoVid,
    props: { pageMarkdownFileName: "page-not-found.markdown" },
    name: "page-not-found"
  },
  {
    path: "/grass-lands/",
    component: GrassLandsPartners,
    props: { pageMarkdownFileName: "grass-lands-partners.markdown" },
    name: "grass-lands-partners"
  },
  {
    path: "/past-lineups/",
    component: PastLineups,
    props: { pageMarkdownFileName: "past-lineups.markdown" },
    name: "past-lineups"
  },
  {
    path: "/restaurant-partners/",
    component: RestaurantPartners,
    props: { pageMarkdownFileName: "restaurant-partners.markdown" },
    name: "restaurant-partners"
  },
  {
    path: "/soma-tent/",
    component: SomaTent,
    props: { pageMarkdownFileName: "soma-tent.markdown" },
    name: "SomaTent"
  },
  {
    path: "/outsider-art/",
    component: OutsiderArt,
    props: { pageMarkdownFileName: "outsider-art.markdown" },
    name: "art"
  },
  {
    path: "/night-shows/",
    component: NightShows,
    props: { pageMarkdownFileName: "night-shows.markdown" },
    name: "NightShows"
  },
  {
    path: "/sign-up/",
    component: Home,
    props: { pageMarkdownFileName: "index.markdown" },
    name: "home-sign-up"
  },
  {
    path: "/health-and-safety/",
    component: HealthAndSafety,
    props: { pageMarkdownFileName: "health-and-safety.markdown" },
    name: "health-and-safety"
  },
  {
    path: "/information/",
    component: Info,
    props: { pageMarkdownFileName: "info.markdown" },
    name: "info"
  },
  {
    path: "/news-mobile/",
    component: News,
    props: { pageMarkdownFileName: "news.markdown" },
    name: "news"
  },
  {
    path: "/schedule/",
    component: Schedule,
    props: { pageMarkdownFileName: "schedule.markdown" },
    name: "schedule"
  },
  {
    path: "/gastro-magic/",
    component: GastroMagic,
    props: { pageMarkdownFileName: "gastro-magic.markdown" },
    name: "gastro-magic"
  },
  {
    path: "/gastro-magic/friday/",
    component: GastroMagic,
    props: { pageMarkdownFileName: "gastro-magic.markdown" },
    name: "friday"
  },
  {
    path: "/gastro-magic/saturday/",
    component: GastroMagic,
    props: { pageMarkdownFileName: "gastro-magic.markdown" },
    name: "saturday"
  },
  {
    path: "/gastro-magic/sunday/",
    component: GastroMagic,
    props: { pageMarkdownFileName: "gastro-magic.markdown" },
    name: "sunday"
  },
  {
    path: "/home/",
    redirect: "/"
  },
  {
    path: "/passes/",
    redirect: "/tickets/"
  },
  {
    path: "/pass/",
    redirect: "/tickets/"
  },
  {
    path: "/ticket/",
    redirect: "/tickets/"
  },
  {
    path: "/taste/",
    redirect: "/"
  },
  {
    path: "/olworks/",
    redirect: "/outside-lands-works/"
  },
  {
    path: "/news/summer-parings/",
    redirect: "/news/summer-pairings/"
  },
  {
    path: "/register/",
    redirect: "https://registration.frontgatetickets.com/#/2019outsidelands"
  }
  // TODO: put back schedule redirect after fest
  /* {
    path: "/schedule/",
    redirect: "/"
  } */
];

/****************************
scroll behavior
****************************/
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

/****************************
Route guard - page not found
****************************/
router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/page-not-found/");
  } else {
    next();
  }
});

Vue.prototype.$site_seo_title_suffix =
  "Outside Lands - October 29-31, 2021: Golden Gate Park : San Francisco, CA";
Vue.prototype.$http = axios;
Vue.prototype.$bgScrollStart = 200;

/****************************
Setup Vue Announcer on route change
****************************/
Vue.use(VueAnnouncer, {}, router);

/****************************
Setup Global Event bus for methods shared between components
****************************/
export const bus = new Vue();

//var d = new Date();
//var n = d.getTime();
var n = v;

axios
  .get("/data/data.json?v=" + n, {
    responseType: "json"
  })
  .then(function(response) {
    if (response.data != null) {
      var siteData = response.data;
      const store = new Vuex.Store({
        state: {
          data: siteData,
          grassLandsModalVisible: false,
          userIs21: false,
          userSeesOsModal: true
        },
        mutations: {
          USER_IS21(state) {
            state.userIs21 = true;
            //console.log('mutations - USER_IS21');
          },
          USER_ISNOT21(state) {
            state.userIs21 = false;
            //console.log('mutations - USER_ISNOT21');
          },
          USER_SEESOSMODAL(state, payload) {
            state.userSeesOsModal = true;
            //console.log('mutations - USER_SEESOSMODAL', payload);
          },
          USER_DOESNOTSEEOSMODAL(state, payload) {
            state.userSeesOsModal = false;
            //console.log('mutations - USER_DOESNOTSEEOSMODAL', payload);
          }
        },
        actions: {
          userIs21(context, payload) {
            context.commit("USER_IS21", payload);
          },
          userIsNot21(context, payload) {
            context.commit("USER_ISNOT21", payload);
          },
          userSeesOSModal(context, payload) {
            context.commit("USER_SEESOSMODAL", payload);
          },
          userDoesNotSeeOsModal(context, payload) {
            context.commit("USER_DOESNOTSEEOSMODAL", payload);
          }
        },
        getters: {
          message(state) {
            //
          },
          data(state) {
            return state.data;
          },
          filterPagesByName: state => name =>
            state.data.filter(data => data.name === name),
          filterPostsByUrl: state => url =>
            state.data.filter(data => data.url === url),
          filterDataByCollection: state => collection =>
            state.data.filter(data => data.collection === collection),
          filterDataByPermalink: state => permalink =>
            state.data.filter(data => data.permalink === permalink),
          getUserIs21(state) {
            return state.userIs21;
          },
          getUserSeesOsModal(state) {
            return state.userSeesOsModal;
          }
        }
        //showGrassLandsModal
      });
      const unsync = sync(store, router); // done. Returns an unsync callback fn
      var app = new Vue({
        el: "#app",
        router,
        watch: {
          $route(to, from) {
            //console.log('from.path: ', from.path);
            if (to.path === "/") {
              //console.log('main - if - to ', to.path);
            }
            if (to.path === "/lineup/") {
              //force page refresh on route change to lineup page to load DoStuff embed
              location.reload();
            }
            if (to.path === "/schedule/") {
              //force page refresh on route change to schedule page to load DoStuff embed
              location.reload();
            }
            if (to.path === "/experience/grass-lands/") {
              if (store.state.userIs21 === false) {
                //console.log('1.2 - /experience/grass-lands/ ', store.state.userIs21);
              }
            } else {
              //console.log('main js - else - to ', to.path);
            }
          }
        },
        store,
        components: {
          app: App
        },
        render(h) {
          return h(App, {
            props: {
              appIsLoaded: this.appIsMounted
            }
          });
        },
        data: {
          appIsMounted: false
        },
        computed: {
          siteData() {
            return store.getters.data;
          }
        },
        mounted() {
          this.appIsMounted = true;
        }
      });
    } else {
      //console.log('else - invalid json: ', response.data)
      //window.location.href = "https://www.google.com";
      var vm = this;
      var siteData = response.data;
      const store = new Vuex.Store({
        state: {
          data: siteData
        },
        mutations: {
          //
        },
        actions: {
          //
        },
        getters: {
          message(state) {
            //
          },
          data(state) {
            return state.data;
          },
          filterPagesByName: state => name =>
            state.data.filter(data => data.name === name),
          filterPostsByUrl: state => url =>
            state.data.filter(data => data.url === url),
          filterDataByCollection: state => collection =>
            state.data.filter(data => data.collection === collection),
          filterDataByPermalink: state => permalink =>
            state.data.filter(data => data.permalink === permalink)
        }
      });
      const unsync = sync(store, router); // done. Returns an unsync callback fn
      var app = new Vue({
        el: "#app",
        router,
        store,
        components: {
          app: App
        },
        render(h) {
          return h(App, {
            props: {
              appIsLoaded: this.appIsMounted
            }
          });
        },
        data: {
          appIsMounted: false
        },
        mounted() {
          this.appIsMounted = false;
        }
      });
    }
  })
  .catch(function(error) {
    console.log("catch - error", error);
    var vm = this;
    var error = null;
    var app = new Vue({
      beforeCreate: function() {
        //console.log('$site_name - ', this.$site_name);
      },
      el: "#app",
      router,
      components: {
        app: App
      },
      //template: '<app :appIsLoaded="appLoaded"></app>',
      //render: function (createElement) {
      //return createElement(App);
      //},
      //render: h => h(App),
      render(h) {
        return h(App, {
          props: {
            appIsLoaded: this.appIsMounted
          }
        });
      },
      data: {
        appIsMounted: false
      },
      mounted() {
        this.appIsMounted = false;
        this.$nextTick(() => {
          /****************************
          DOC READY
          ****************************/
          //$(function() {
          //console.log('DOC READY');
          //});
        });
      }
    });
  });

/****************************
Handle Scrollin in vanilla JS
****************************/

/****************************
SEAF 
****************************/
(function(window) {
  //console.log('SEAF');
})(window);
/****************************
End SEAF 
****************************/

/****************************
Lazy Load images mixin in plain JS
https://css-tricks.com/snippets/javascript/lazy-loading-images/
https://css-tricks.com/lozad-js-performant-lazy-loading-images/
****************************/
